<template>
	<div class="content">
		<div class="content_head">
			
			<select v-model="ShopID" title="选择店铺" @change="getData()" v-if="$store.state.user.UserType==0">
				<option v-for="i in $store.state.shop" :value="i.ShopID"  >
					{{i.ShopName}}
				</option>
			</select>
			
			<input type="text" @keypress.enter="getData()" placeholder="书籍编码|书籍名称" class="search"
				v-model="search"  style="height: 2rem;"/>&nbsp;&nbsp;
				
		<select v-model="state" style="padding-right: .5rem;"  @change="getData()" >
			<option value="0">正常</option>
			<option value="1">下架</option>
			<option value="2">借出</option>
		</select>
			<button type="button" class="button " @click="getData()" title="点击进行查找">查找</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>书籍名称</th>
						<th>书籍编号</th>
						<th>书籍位置</th>
						<th>借出次数</th>
						<th>书籍状态</th>
						<th>备注</th>
						<th>历史记录</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in books">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.BooksName}}
						</td>
						<td>
							{{i.BooksNumCode}}
						</td>
						<td>
							{{i.ShopName +':'+i.CurrentPlace}}
						</td>
						<td>
							{{i.borrowCount}}
						</td>
						<td>
							{{i.BooksSate | bookState}}
						</td>
						<td>
							{{i.BooksDesc}}
						</td>
						
						<td>
							<button type="button" class="button" @click="$router.replace('/queryBook/queryBookBorrowHistory/'+i.BookDetailID)"
								title="点击查看图书借出记录">
								借出记录
							</button>	
							<br/>
							<button type="button" class="button" @click="$router.replace('/queryBook/queryBookMoveHistory/'+i.BookDetailID)"
								title="点击查看图书移动记录">
								信息记录
							</button>	
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
	
			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="15">15/页</option>
				<option value="20">20/页</option>
				<option value="25">25/页</option>
				<option value="30">30/页</option>
	
			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>
	
</template>

<script>
	import j from './j.js'
	export default j
</script>

<style>
</style>
